// Mantine
import { Button } from '@mantine/core'

// Classnames
import classNames from 'classnames'

// Next
import { Link } from 'react-router-dom'

export default function Box({
    children,
    title,
    subtitle,
    innerRef,
    rightSection,
    action,
    actionLabel = 'Modifier',
    globalAction = false,
    href,
    fullHeight = false,
    maxHeight,
}) {
    const hasFirstBlock = title || subtitle || rightSection || action

    const classes = classNames(
        'bg-white rounded-xl flex flex-col border overflow-hidden relative',
        {
            'cursor-pointer hover:bg-gray-50':
                (globalAction === true && action) || href,
            'h-full': fullHeight === true,
        }
    )

    const boxContent = (
        <>
            {hasFirstBlock && (
                <div className="flex flex-col px-4 pt-4 pb-3 border-b border-b-gray-100">
                    <div className="flex justify-between items-center gap-2">
                        {title && (
                            <span className="font-medium truncate">
                                {title}
                            </span>
                        )}

                        <div className="flex items-center gap-2 shrink-0">
                            {rightSection}

                            {action && (
                                <Button
                                    variant="default"
                                    onClick={
                                        globalAction === false && action
                                            ? action
                                            : undefined
                                    }
                                >
                                    {actionLabel}
                                </Button>
                            )}
                        </div>
                    </div>

                    {subtitle && (
                        <span className="text-gray-400 text-sm">
                            {subtitle}
                        </span>
                    )}
                </div>
            )}

            <div
                className="h-full p-4 overflow-y-auto"
                style={maxHeight ? { maxHeight } : undefined}
            >
                {children}
            </div>
        </>
    )

    if (href) {
        return (
            <Link to={href} className="block">
                <div className={classes} ref={innerRef}>
                    {boxContent}
                </div>
            </Link>
        )
    }

    return (
        <div
            className={classes}
            ref={innerRef}
            onClick={globalAction === true && action ? action : undefined}
        >
            {boxContent}
        </div>
    )
}
